import { ContentLoader } from "../../../../components";
import Localization from "../../../../localization";
import { Enums, Tools } from "../../../../utils";
import { useEffect, useState } from "react";
import useViewModel from "../../viewModel";
import { SVGs } from "../../../../assets";
import Customer from "./customer";
import Contacts from "./contacts";
import Actions from "./actions";
import Summary from "./summary";

const Settings = () => {
  const { getArc = async () => {}, updateArc = async () => {} } =
    useViewModel();
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [arc, setArc] = useState({
    actions: [],
    contacts: [],
    customer: {},
  });
  const [summary, setSummary] = useState(arc);

  useEffect(() => {
    get();
  }, []);

  useEffect(() => {
    const summary = { ...arc };
    summary.contacts = summary.contacts.map((contact, index) => {
      const isOwner = !index;
      const isAdmin = !isOwner && contact.authority === 5;
      return {
        ...contact,
        isOwner,
        title: [
          isOwner && <SVGs.star color="currentColor" className="m-5-r" />,
          Tools.ellipseMe(contact.name),
          isOwner && ` (${Localization.general.owner})`,
          isAdmin && ` (${Localization.general.admin})`,
        ].filter(Boolean),
        codeWord: !contact.password
          ? Localization.general.no_code_word
          : `${Localization.general.code_word}: ${contact.password}`,
      };
    });
    summary.actions = summary.actions.map((_) => ({
      ..._,
      title: Enums.details(_.type).title,
      value: Actions.options[_.action],
    }));
    setSummary(summary);
  }, [arc]);

  useEffect(() => {
    document.getElementById("header").scrollIntoView();
  }, [progress]);

  const get = async () => {
    setLoading(true);
    try {
      const arc = await getArc();
      setArc(arc);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const onNext = () => setProgress((_) => _ + 1);

  const onBack = () => setProgress((_) => _ - 1);

  if (loading)
    return (
      <ContentLoader
        skeletons={[
          { size: "small", className: "w-70" },
          { height: 50 },
          { size: "large", height: 300 },
          { size: "large", shape: "round", height: 40 },
        ]}
      />
    );
  return (
    <div>
      <div id="header" style={{ scrollMarginTop: "2em" }} />
      {
        [
          <Customer
            customer={{
              ...arc.customer,
              password: arc?.contacts[0]?.password ?? "",
            }}
            onNext={({ password, ...customer }) => {
              const data = { ...arc };
              data.customer = customer;
              data.contacts[0] = {
                password,
                authority: 5,
                name: customer.name,
                phone: customer.phone,
                email: customer.email,
              };
              setArc(data);
              onNext();
            }}
          />,
          <Contacts
            onBack={onBack}
            onNext={onNext}
            contacts={summary.contacts}
            onAdd={(contact) => {
              setArc({ ...arc, contacts: [...arc.contacts, contact] });
            }}
            onEdit={(index, contact) => {
              arc.contacts[index] = contact;
              setArc({ ...arc, contacts: [...arc.contacts] });
            }}
            onRemove={(indexes = []) => {
              setArc({
                ...arc,
                contacts: arc.contacts.filter((_, i) => !indexes.includes(i)),
              });
            }}
          />,
          <Actions
            onBack={onBack}
            onNext={onNext}
            actions={summary.actions}
            onSelect={(type, index) => {
              const actions = [...arc.actions];
              actions[arc.actions.findIndex((_) => _.type === type)].action =
                index;
              setArc({ ...arc, actions });
            }}
          />,
          <Summary
            {...summary}
            onDone={() => updateArc(arc)}
            onBack={onBack}
          />,
        ][progress]
      }
    </div>
  );
};

export default Settings;
